import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message, Spin, Radio, Space } from "antd";
import { ALSFRS_FIELDS } from "../../utils/consts";
import Bridge from "../../utils/Bridge";

export default class ALSFRS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      speech: "",
      salvation: "",
      swallowing: "",
      handwriting: "",
      cutting_food_a: "",
      cutting_food_b: "",
      dressing_and_hygiene: "",
      turning_in_bed: "",
      walking: "",
      climbing_stairs: "",
      dyspnea: "",
      orthopnea: "",
      respiratory_insufficiency: "",
    };
  }
  save_alsfrs = () => {
    if (this.state.speech === "" && this.state.speech !== 0) {
      message.warning("Please select Speech value");
      return;
    }
    if (this.state.salvation === "" && this.state.salvation !== 0) {
      message.warning("Please select Salvation value");
      return;
    }
    if (this.state.swallowing === "" && this.state.swallowing !== 0) {
      message.warning("Please select Swallowing value");
      return;
    }
    if (this.state.handwriting === "" && this.state.handwriting !== 0) {
      message.warning("Please select Handwriting value");
      return;
    }
    if (
      this.state.cutting_food_a === "" &&
      this.state.cutting_food_a !== 0 &&
      this.state.cutting_food_b === "" &&
      this.state.cutting_food_b !== 0
    ) {
      message.warning(
        "Please select 'Cutting food and handling utensils' value"
      );
      return;
    }
    if (
      this.state.dressing_and_hygiene === "" &&
      this.state.dressing_and_hygiene !== 0
    ) {
      message.warning("Please select 'Dressing and Hygiene' value");
      return;
    }
    if (this.state.turning_in_bed === "" && this.state.turning_in_bed !== 0) {
      message.warning("Please select 'Turning in bed' value");
      return;
    }
    if (this.state.walking === "" && this.state.walking !== 0) {
      message.warning("Please select 'Walking' value");
      return;
    }
    if (this.state.climbing_stairs === "" && this.state.climbing_stairs !== 0) {
      message.warning("Please select 'Climbing Stairs' value");
      return;
    }
    if (this.state.dyspnea === "" && this.state.dyspnea !== 0) {
      message.warning("Please select 'Dyspnea' value");
      return;
    }
    if (this.state.orthopnea === "" && this.state.orthopnea !== 0) {
      message.warning("Please select 'Orthopnea' value");
      return;
    }
    if (
      this.state.respiratory_insufficiency === "" &&
      this.state.respiratory_insufficiency !== 0
    ) {
      message.warning("Please select 'Respiratory Insufficiency' value");
      return;
    }
    let cutting_food_value = 0;
    if (this.state.cutting_food_a != "") {
      cutting_food_value = this.state.cutting_food_a;
    } else if (this.state.cutting_food_b != "") {
      cutting_food_value = this.state.cutting_food_b;
    }
    let total =
      Number(this.state.speech) +
      Number(this.state.salvation) +
      Number(this.state.swallowing) +
      Number(this.state.handwriting) +
      Number(cutting_food_value) +
      Number(this.state.dressing_and_hygiene) +
      Number(this.state.turning_in_bed) +
      Number(this.state.walking) +
      Number(this.state.climbing_stairs) +
      Number(this.state.dyspnea) +
      Number(this.state.orthopnea) +
      Number(this.state.respiratory_insufficiency);

    let params = {
      speech: this.state.speech,
      salvation: this.state.salvation,
      swallowing: this.state.swallowing,
      handwriting: this.state.handwriting,
      cutting_food_a: this.state.cutting_food_a,
      cutting_food_b: this.state.cutting_food_b,
      dressing_and_hygiene: this.state.dressing_and_hygiene,
      turning_in_bed: this.state.turning_in_bed,
      walking: this.state.walking,
      climbing_stairs: this.state.climbing_stairs,
      dyspnea: this.state.dyspnea,
      orthopnea: this.state.orthopnea,
      respiratory_insufficiency: this.state.respiratory_insufficiency,
      eals_id: localStorage.getItem("ap_eals_id"),
      ALS_total: total,
    };

    this.setState({ loading: true });
    Bridge.eals_frs
      .save(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              speech: "",
              salvation: "",
              swallowing: "",
              handwriting: "",
              cutting_food_a: "",
              cutting_food_b: "",
              dressing_and_hygiene: "",
              turning_in_bed: "",
              walking: "",
              climbing_stairs: "",
              dyspnea: "",
              orthopnea: "",
              respiratory_insufficiency: "",
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/dashboard");
              }, 2000);
            }
          );
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try again!!");
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <Spin spinning={this.state.loading}>
                  <div className="demographic-single-section">
                    <a
                      href="/dashboard"
                      style={{ width: 95 }}
                      className="back-arrow"
                    >
                      <box-icon
                        name="chevron-left"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                      Back
                    </a>
                    <div>
                      <div className="header">
                        <h3>ADD ALSFRS</h3>
                        <div className="white-block"></div>
                      </div>
                      <Spin spinning={this.state.loading}>
                        <div className="form-fields">
                          {ALSFRS_FIELDS.map((item, index) => {
                            return (
                              <div className="form-group" index={index}>
                                <label className="mb-2 input-heading">
                                  {item.title}{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <br />
                                <Radio.Group
                                  onChange={(e) =>
                                    this.setState({
                                      [item.text]: e.target.value,
                                    })
                                  }
                                  value={this.state[item.text]}
                                  direction="vertical"
                                >
                                  <Space direction="vertical">
                                    {item.content.map((single, i) => {
                                      return (
                                        <Radio value={single.points} index={i}>
                                          {single.subtitle}
                                        </Radio>
                                      );
                                    })}
                                  </Space>
                                </Radio.Group>
                              </div>
                            );
                          })}
                          <div className="d-flex mt-5">
                            <button
                              className="submit-button ml-2"
                              style={{
                                marginLeft: 0,
                                padding: "9px 15px 10px 20px",
                              }}
                              onClick={() => this.save_alsfrs()}
                            >
                              Save{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 1 }}
                              ></box-icon>
                            </button>
                          </div>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
